<template>
    <main>
        <AppIpadBackground />
        <AppSiteHeader />
        <div class="container">
            <div class="page">
                <div class="welcome">
                    <h1 class="big">{{ $t('thank_you.title')}}</h1>
                    <h2 class="small">{{ $t('thank_you.sub_title')}}</h2>
                    <p class="top_padded">{{ $t('thank_you.description_1')}}</p>
                    <p class="top_padded">{{ $t('thank_you.description_2')}}</p>
                    <a class="primary_btn" target="_blank" href="https://bit.ly/302e1Ed">{{ $t('buttons.learn_more_button')}}</a>
                    &nbsp;
                    <social-sharing url="https://psa-spiel-rs-online.de" title="Unsere Produktpalette ist ideal für einen optimalen Schutz, unabhängig von Ihrem Tätigkeitsbereich. Wählen Sie die richtige Schutzausrüstung für jedes Arbeitsszenario und nehmen Sie an der Verlosung eines iPads teil." inline-template>
                        <div>
                            <network network="facebook">
                                <img src="../../public/assets/fb_share.png" alt="" width="35px" style="cursor: pointer;">
                            </network>
                            &nbsp;
                            <network network="twitter">
                                <img src="../../public/assets/twitter_share.png" alt="" width="35px" style="cursor: pointer;">
                            </network>
                        </div>
                    </social-sharing>
                </div>
            </div>
        </div>
        <AppSiteFooter />
    </main>
</template>
<script>
import axios from 'axios';
import AppIpadBackground from '@/components/AppIpadBackground'
import AppSiteHeader from '@/components/AppSiteHeader'
import AppSiteFooter from '@/components/AppSiteFooter'
import appStyles from '@/styles/appStyles.scss'

export default {
    name: 'register',
    components: {
        appStyles,
        AppSiteHeader,
        AppSiteFooter,
        AppIpadBackground
    },
    data() {
        return {}
    },
    methods: {},
    mounted() {
        this.$session.destroy();
    },
    beforeMount() {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.play_again {
    color: $color__secondary;
}

.big {
    font-size: 40px;
}

.small {
    font-size: 22px;
}
</style>